// TODO: make type safe
import { StoryblokComponent } from 'gatsby-source-storyblok';
import React, { useEffect, useState } from 'react';
import { blokToComponent } from '../../helpers/blok-to-component';
import { filterProps } from '../../helpers/filter-props';
import { StoryItem, StoryTeaserService } from '../../services/story-teaser';
import { parseAssetSource } from '../../utils/asset';
import { TeaserService } from '../../services/teaser';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';

export const RocheStoryStagingHero = ({
  blok,
  slot,
  getComponent,
  updateHoistedState,
  storyId,
}: BlokToComponentProps<any>): JSX.Element => {
  const [teaser, setTeaser] = useState<StoryItem>(blok.preRenderContent || ({} as StoryItem));
  useEffect(() => {
    if (!storyId) {
      return;
    }
    if (!teaser || Object.keys(teaser).length === 0) {
      StoryTeaserService.getStoryTeaser(storyId as number).then((result) => {
        if (result === undefined) {
          // edge case: could not load teaser of story, try loading teaser of page
          // functionality should be changed: https://roche-ds.atlassian.net/browse/EXTCWP-844
          return TeaserService.getTeaser(storyId as number).then(async (result) => {
            setTeaser(result);
            return updateHoistedState?.(1, 1, blok._uid, result);
          });
        } else {
          setTeaser(result);
          return updateHoistedState?.(1, 1, blok._uid, result);
        }
      });
    } else {
      // teaser information already set by preRenderContent
      updateHoistedState?.(1, 1, blok._uid, teaser);
    }
  }, []);

  const teaserImage = blok?.slotted_story_image?.[0];
  const { slotted } = filterProps(blok);
  const children = Object.keys(slotted).reduce((acc, key) => {
    const slottedComponents = (slotted[key] as StoryblokComponent<string>[]).map((component) => ({
      ...component,
      ratio: '2.39:1',
      bleed: true,
      slot: key,
    }));

    return [...acc, ...slottedComponents];
  }, []);

  return (
    <roche-story-staging-hero
      layout={blok?.layout}
      story-type={teaser?.content?.teaser_type}
      story-description={blok?.story_description}
      show-tags={blok?.show_tags}
      story-image={parseAssetSource(teaserImage?.src.filename) || teaserImage?.brightcove_id}
      story-tags={teaser?.content?.tag}
      slot={slot}
    >
      <h1 slot='headline'>{blok?.story_headline}</h1>
      {children.map((child, index) => blokToComponent({ blok: child, getComponent }, `${index}`))}
    </roche-story-staging-hero>
  );
};
